import MTable from 'components/Table/Table'
import Mpopup from "components/Mpopup/Mpopup"
import 'vant/es/toast/style';
import Modal from "components/Modal/Modal"
import Region from "lib/region"
import util from "lib/util"
import wx from 'weixin-js-sdk'

export default {
  name: 'batchPrice',
  components: {
    MTable,
    Mpopup,
    Modal
  },
  data() {
    return {
      customerId: '',
      kuaidiCom: '',
      type: '',
      source: '',
      tableData: [
        // { toAddress: "天津", grads: '0-1单', firstPrice: 5.8, overPriceUnit: 2 },
        // { toAddress: "天津", grads: '2-5单', firstPrice: 5.7, overPriceUnit: 2 },
        // { toAddress: "天津", grads: '6-10单', firstPrice: 5.6, overPriceUnit: 2 },
        // { toAddress: "北京", grads: '0-1单', firstPrice: 6.8, overPriceUnit: 2.5 },
        // { toAddress: "北京", grads: '2-5单', firstPrice: 6.7, overPriceUnit: 2.5 },
        // { toAddress: "上海", grads: '0-1单', firstPrice: 7.5, overPriceUnit: 3 },
      ],
      tableColumns: [
        { title: '收件地址', prop: 'toAddress', align: 'center' },
        { title: '日梯度', prop: 'grads', align: 'center' },
        { title: '0-1单', prop: 'firstPrice', align: 'center' },
        { title: '续重/kg', prop: 'overPriceUnit', align: 'center' }
      ],
      companyList: [],
      // 自动合并的列属性
      mergeProps: ['toAddress'],
      sendxzq: '',
      recxzq: '',
      pickmode: 'sendxzq',
      defaultxzq: '广东省,深圳市,南山区',
      protocolInfo: '',
      showProtocol: false,
      token: '',
      env: '',
      currentSelectCom: {},
      isCityDimension: false, //是否城市维度
      isAddressExpanded: false,
      selectedAddressIndex: -1,
      showSwitchAddressModal: false,
      pendingAddressIndex: -1,
      addressList: [],
      saddrid: '',
      sendName: '',
      fromMobile: '',
      sendAddr: '',
      from: '',
      plainMobileCache: {},
    };
  },
  computed: {
    showTableData() {
      if( !this.tableData.length ) {
        return false;
      } else {
        if (this.isCityDimension && !this.recxzq) {
          return false
        } else {
          return true
        }
      }
    },
    currentAddress() {
      if (this.selectedAddressIndex < 0) return null
      return this.addressList[this.selectedAddressIndex] || null
    },
    pendingAddress() {
      if (this.pendingAddressIndex < 0) return null
      return this.addressList[this.pendingAddressIndex] || null
    },
    // 寄件页带过来的原寄件地址（按姓名/手机号/详细地址一一对应）
    originAddress() {
      if (!this.hasOriginAddressInfo) return null
      const matched = this.addressList.find((item) => this.isMatchOriginAddress(item))
      if (matched) return matched
      // 列表未匹配到时，用 URL 带入信息展示「原地址」
      const [province = '', city = '', district = ''] = String(this.sendxzq || '').split(',')
      return {
        addressId: null,
        orderId: '',
        name: this.sendName || '',
        mobile: this.fromMobile || '',
        province,
        city,
        district,
        address: this.sendAddr || '',
        detailAddress: this.sendAddr || '',
        isCurrent: true,
      }
    },
    hasOriginAddressInfo() {
      return !!(this.sendName || this.fromMobile || this.sendAddr)
    },
  },
  created() {
    const paramsToken = util.query('token') || '' //路径携带了token
    this.sendxzq = util.query('sendxzq') || this.defaultxzq //没有寄件地址时使用默认地址
    this.recxzq = util.query('recxzq') || ''
    this.customerId = util.query('customerId') || ''
    this.kuaidiCom = util.query('com') || util.query('kuaidiCom') || ''
    this.type = util.query('type') || ''
    this.source = util.query('source') || ''
    this.saddrid = util.query('saddrid') || ''
    this.sendName = util.query('sendName') || ''
    this.fromMobile = util.query('fromMobile') || ''
    this.sendAddr = util.query('sendAddr') || ''
    this.from = util.query('from') || ''
    this.getProtocolInfo()
    if (paramsToken) {
      this.token = paramsToken
      this.queryTodayBatchSenderAddresses()
    }
    util.loadScript("https://cdn.kuaidi100.com/js/share/jssdk/kuaidi100-jssdk.min.js", () => {
      if (typeof window.kuaidi100 == 'object') {
        const env = kuaidi100.getEnv()   
        const userAgent = window.navigator.userAgent.toLowerCase()
        const isWechat = /miniProgram/i.test(window.navigator.userAgent);
        this.env = isWechat ? 'wechat' : env
        console.log(this.env);
        this.getBatch4Band()
        if(isWechat) {
          if (paramsToken) {
            this.token = paramsToken
            console.log('路径携带token', this.token);
          }
        } else {
          // 一般小程序获取不了token，从路径里获取，app用 sdk 去获取
          if (paramsToken) {
            this.token = paramsToken
          } else {
            kuaidi100.getToken({
              success: (token) => {
                console.log(`获取到的token${token}`);
                this.token = token
                this.queryTodayBatchSenderAddresses()
              },
            })
          }
        }
      }
    })
  },
  mounted() {
    this.region = new Region({
      others: null,
      level: 2,
      value: ("").split(","),
      confirm: result => {
        var str = []
        for (let i = 0, len = result.length; i < len; i++) {
          result[i] && (result[i].name) && str.push(result[i].name)
        }
        if(this[this.pickmode] !== str.join(",")) {
          this[this.pickmode] = str.join(",")
          console.log(this[this.pickmode]);
          this.getBatch4Band()
        }
        
      },
    })
  },
  beforeDestroy() {
    this.region.hide()
  },
  methods: {
    handleSelectCompany(com) {
      if (com.kuaidiCom === this.currentSelectCom.kuaidiCom) return
      this.currentSelectCom = com
      this.type = this.currentSelectCom.orderType || ''
      this.getPriceList()
      // 品牌切换后，按当前品牌重新计算各地址当日有效单量
      this.queryTodayBatchSenderAddresses({ preserveState: true })
    },
    normalizeSenderAddress(item) {
      const addressId = item.addressId
      const orderId = item.orderId != null && item.orderId !== '' ? String(item.orderId) : ''
      const name = item.senderName || ''
      const mobile = item.senderPhone || ''
      const address = item.detailAddress || item.fullAddress || ''
      const orderCount = Number(item.todayOrderCount) || 0
      return {
        addressId,
        orderId,
        senderName: name,
        senderPhone: mobile,
        province: item.province || '',
        city: item.city || '',
        district: item.district || '',
        detailAddress: item.detailAddress || '',
        fullAddress: item.fullAddress || '',
        todayOrderCount: orderCount,
        name,
        mobile,
        address,
        orderCount,
        isCurrent: false,
      }
    },
    formatFullAddress(item) {
      if (!item) return ''
      if (item.fullAddress) return item.fullAddress
      const detail = item.address || item.detailAddress || item.addr || ''
      const xzq = [item.province, item.city, item.district].filter(Boolean).join('')
      if (!xzq) return detail
      if (!detail) return xzq
      // 详情已含省市区时避免重复拼接
      if (detail.indexOf(xzq) === 0 || (item.province && detail.indexOf(item.province) === 0)) {
        return detail
      }
      return `${xzq}${detail}`
    },
    isSameMobile(a, b) {
      if (!a || !b) return false
      if (a === b) return true
      const digitsA = String(a).replace(/\D/g, '')
      const digitsB = String(b).replace(/\D/g, '')
      if (digitsA && digitsB && digitsA === digitsB) return true
      // 兼容脱敏号：155****1234
      if (String(a).includes('*') || String(b).includes('*')) {
        return String(a).slice(0, 3) === String(b).slice(0, 3)
          && String(a).slice(-4) === String(b).slice(-4)
      }
      return false
    },
    isSameDetailAddr(item, sendAddr) {
      if (!item || !sendAddr) return false
      const candidates = [
        item.address,
        item.detailAddress,
        item.fullAddress,
        item.addr,
        this.formatFullAddress(item),
      ].filter(Boolean)
      return candidates.some((addr) => {
        return addr === sendAddr || addr.indexOf(sendAddr) > -1 || sendAddr.indexOf(addr) > -1
      })
    },
    // 当前下单：姓名、手机号、详细地址一一对应
    isMatchOriginAddress(item) {
      if (!item || !this.hasOriginAddressInfo) return false
      const nameMatch = !this.sendName || item.name === this.sendName
      const mobileMatch = !this.fromMobile || this.isSameMobile(item.mobile, this.fromMobile)
      const addrMatch = !this.sendAddr || this.isSameDetailAddr(item, this.sendAddr)
      return nameMatch && mobileMatch && addrMatch
    },
    // 选中地址是否与路径参数寄件地址一致
    isSameAsPathAddress(item) {
      if (!item || !this.hasOriginAddressInfo) return false
      // 路径参数生成的「当前下单」条目
      if (item.isCurrent) return true
      return (item.name || '') === (this.sendName || '')
        && this.isSameMobile(item.mobile, this.fromMobile)
        && (
          (item.address || '') === (this.sendAddr || '')
          || this.isSameDetailAddr(item, this.sendAddr)
        )
    },
    // 路径带入的寄件地址（固定作为列表第一条）
    buildPathAddressItem(dup) {
      const [province = '', city = '', district = ''] = String(this.sendxzq || '').split(',')
      const addressId = dup ? dup.addressId : null
      const orderId = dup ? dup.orderId : null
      return {
        addressId,
        orderId,
        senderName: this.sendName || '',
        senderPhone: this.fromMobile || '',
        province,
        city,
        district,
        detailAddress: this.sendAddr || '',
        fullAddress: `${province}${city}${district}${this.sendAddr || ''}`,
        todayOrderCount: Number((dup && dup.orderCount) || 0) || 0,
        name: this.sendName || '',
        mobile: this.fromMobile || '',
        address: this.sendAddr || '',
        orderCount: Number((dup && dup.orderCount) || 0) || 0,
        isCurrent: true,
      }
    },
    applyAddressList(list = [], options = {}) {
      const { preserveState = false } = options
      const prevSelectedIndex = this.selectedAddressIndex
      const prevExpanded = this.isAddressExpanded
      const normalized = (list || []).map((item) => this.normalizeSenderAddress(item))
      if (!preserveState) {
        this.isAddressExpanded = false
      }
      if (!this.hasOriginAddressInfo) {
        this.addressList = normalized
      } else {
        // 路径参数作为第一条；接口中同名同号同址的重复数据剔除，单量并入首条
        const dup = normalized.find((item) => this.isMatchOriginAddress(item))
        const pathItem = this.buildPathAddressItem(dup)
        const others = normalized
          .filter((item) => !this.isMatchOriginAddress(item))
          .map((item) => ({
            ...item,
            isCurrent: false,
          }))
        this.addressList = [pathItem, ...others]
      }
      if (preserveState && prevSelectedIndex >= 0 && prevSelectedIndex < this.addressList.length) {
        this.selectedAddressIndex = prevSelectedIndex
        this.isAddressExpanded = prevExpanded
        return
      }
      const currentIndex = this.addressList.findIndex((item) => item.isCurrent)
      this.selectedAddressIndex = currentIndex >= 0 ? currentIndex : (this.addressList.length ? 0 : -1)
      if (preserveState) {
        this.isAddressExpanded = prevExpanded
      }
    },
    queryTodayBatchSenderAddresses(options = {}) {
      const { preserveState = false } = options
      const address = (this.sendxzq || '').replace(/,/g, '')
      if (!address || !this.token) {
        if (!preserveState) {
          this.applyAddressList([])
        }
        return
      }
      const brand = this.currentSelectCom || {}
      const params = {
        data: {
          address,
          token: this.token || '',
          // 按当前快递品牌维度统计当日有效单量
          customerId: brand.customerId || this.customerId || '',
          kuaidiCom: brand.kuaidiCom || this.kuaidiCom || '',
          orderType: this.type,
        },
        headers: {
          token: this.token || '',
        },
        outside: true,
        handleLogin: false
      }
      this.$http.post("/perapi-order/order/queryBatchSenderAddressesByRegion", params).then((res) => {
        // $http 拦截器已返回 { status, message, data }
        if (!res || res.status != 200) {
          if (!preserveState) {
            this.applyAddressList([])
          }
          return
        }
        const payload = res.data
        const list = Array.isArray(payload)
          ? payload
          : (Array.isArray(payload && payload.list) ? payload.list : [])
        this.applyAddressList(list, { preserveState })
      }).catch(() => {
        if (!preserveState) {
          this.applyAddressList([])
        }
      })
    },
    getProtocolInfo() {
      this.$http.get(`https://a.kuaidi100.com/crm/open/privacySetting/findByCondition?termId=900030001&termType=00`, {
        handleFail: false,
        handleLogin: false
      }).then(res => {
        if (res.data && res.data.length) {
          const info = res.data[0]
          this.protocolInfo = info?.note
        }
      })
    },
    getBatch4Band() { //获取可用的快递公司列表
      // const url = "/apicenter/order.do?method=availableCom4BrandBatch"
      // const params = {
      //   data: {
      //     saddrid: '',
      //     sendxzq: this.sendxzq,
      //     sendAddr: '',
      //     latitude: '',
      //     longitude: '',
      //     recList: this.getRecmanList(),
      //     openOnline: 'Y',
      //     apiversion: 23,
      //     token: this.token || '',
      //     platform: this.env === 'wechat' ? 'WEIXINAPP' : this.env,
      //   },
      //   handleLogin: false
      // }
      const url = "/apicenter/order.do?method=availableCompList"
      const params = {
        data: {
          sendxzq: this.sendxzq.split(",").join(""),
          recxzq: this.recxzq.split(",").join(""),
          customerId: this.customerId || '',
          weight: 1,
          source: 'queryPriceList',
          compOrderType: 2
        },
        handleLogin: false
      }
      this.$http.post(url, params).then((res) => {

        this.companyList = res.data
        if (this.companyList.length) {
          // 优先按 URL 中的 com（kuaidiCom）初始化选中运力
          const matched = this.kuaidiCom
            ? this.companyList.find((item) => item.kuaidiCom === this.kuaidiCom)
            : null
          this.currentSelectCom = matched || this.companyList[0]
          this.getPriceList()
          this.queryTodayBatchSenderAddresses()
        } else {
          this.$toast("暂无可用快递公司")
        }
      })
    },
    getPriceList() {
      if (!this.currentSelectCom || !this.currentSelectCom.customerId) return
      this.resolvePlainMobile(this.currentAddress).then((fromMobile) => {
        this.fetchBatchPriceList(fromMobile)
      })
    },
    isMaskedMobile(mobile) {
      return !!(mobile && String(mobile).indexOf('*') > -1)
    },
    getAddressBookId(address) {
      const addressId = address && address.addressId
      if (addressId == null || addressId === '' || String(addressId) === '0') {
        return ''
      }
      return String(addressId)
    },
    // 密文手机号：有地址簿 id 走地址簿；否则有 orderId 走订单明文接口
    resolvePlainMobile(address) {
      const mobile = (address && address.mobile) || ''
      if (!mobile || !this.isMaskedMobile(mobile)) {
        return Promise.resolve(mobile)
      }
      if (address && address.plainMobile && !this.isMaskedMobile(address.plainMobile)) {
        return Promise.resolve(address.plainMobile)
      }
      const addrId = this.getAddressBookId(address)
      if (addrId) {
        if (this.plainMobileCache[addrId]) {
          return Promise.resolve(this.plainMobileCache[addrId])
        }
        return this.$http.get('/baseaddress/querySingleAddressBook', {
          data: {
            addrId,
            location: 1,
            addrVersion: 0,
            token: this.token || '',
          },
          outside: true,
          handleLogin: false,
          handleFail: false,
        }).then((res) => {
          if (!res || res.status != 200 || !res.data) {
            return mobile
          }
          const phone = res.data.phone || res.data.mobile || res.data.senderPhone || ''
          if (!phone || this.isMaskedMobile(phone)) {
            return mobile
          }
          this.$set(this.plainMobileCache, addrId, phone)
          if (address) {
            this.$set(address, 'plainMobile', phone)
          }
          return phone
        }).catch(() => mobile)
      }
      const orderId = address && address.orderId
      if (!orderId) {
        return Promise.resolve(mobile)
      }
      const cacheKey = `order_${orderId}`
      if (this.plainMobileCache[cacheKey]) {
        return Promise.resolve(this.plainMobileCache[cacheKey])
      }
      return this.$request('/perapi-system/sensitive/plaintext', {
        contentType: 'application/json',
        data: {
          cname: 'sendmobile',
          text: mobile,
          type: 'order',
          sid: String(orderId),
          token: this.token || '',
        },
        handleFail: false,
      }).then((res) => {
        const payload = res && res.data
        const phone = typeof payload === 'string'
          ? payload
          : ((payload && (payload.text || payload.plaintext)) || '')
        if (!phone || this.isMaskedMobile(phone)) {
          return mobile
        }
        this.$set(this.plainMobileCache, cacheKey, phone)
        if (address) {
          this.$set(address, 'plainMobile', phone)
        }
        return phone
      }).catch(() => mobile)
    },
    fetchBatchPriceList(fromMobile) {
      const params = {
        data: {
          customerId: this.currentSelectCom.customerId,
          fromProvince: this.sendxzq.split(",")[0],
          fromCity: this.sendxzq.split(",")[1],
          toProvince: this.recxzq.split(",")[0] || '',
          toCity: this.recxzq.split(",")[1] || '',
          type: this.currentSelectCom.orderType,
          fromAddr: (this.currentAddress && this.currentAddress.address) || '',
          fromMobile: fromMobile || '',
          // source: 'queryPriceList'
          // token: this.token || '',
          // platform: this.env === 'wechat' ? 'WEIXINAPP' : this.env,
        },
        outside: true,
        handleLogin: false
      }
      this.$http.post("/apicenter/order.do?method=getBatchPriceList", params).then((res) => {
        if (res.status !== 200) {
          // this.$toast(res.message)
          this.tableData = []
          this.tableColumns = []
          this.isCityDimension = false
          return
        }
        this.isCityDimension = false
        this.tableData = res.data?.tableData || []
        this.tableColumns = res.data?.tableHeader || []
        if(this.tableData.length) {
          let isCityDimension = false
          this.tableData.forEach((item)=> {
            if(item.toAddress.includes('市')) {
              isCityDimension = true
            }
          })
          this.isCityDimension = isCityDimension
        }
        // this.tableColumns = [
        //   {'title': '收件地址', 'prop': 'toAddress'},
        //   {'title': '日梯度', 'prop': 'grads'},
        //   {'title': '0-1kg', 'prop': 'price_0'},
        //   {'title': '续重1kg', 'prop': 'price_1'},
        //   {'title': '1-3kg', 'prop': 'price_2'},
        //   {'title': '3-6kg', 'prop': 'price_3'},
        // ]
        // this.tableData = [
        //   {'price_0': '12', 'grads': '0-1单', 'price_1': '6', 'price_2': '15', 'price_3': '22', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '2-5单', 'price_1': '6', 'price_2': '18', 'price_3': '28', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '6-10单', 'price_1': '6', 'price_2': '20', 'price_3': '30', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '11-20单', 'price_1': '6', 'price_2': '23', 'price_3': '35', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '20单以上', 'price_1': '6', 'price_2': '25', 'price_3': '40', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '0-1单', 'price_1': '6', 'price_2': '15', 'price_3': '22', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '2-5单', 'price_1': '6', 'price_2': '18', 'price_3': '28', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '6-10单', 'price_1': '6', 'price_2': '20', 'price_3': '30', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '11-20单', 'price_1': '6', 'price_2': '23', 'price_3': '35', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '20单以上', 'price_1': '6', 'price_2': '25', 'price_3': '40', 'toAddress': '广东'},
        // ]
        this.tableColumns.forEach(item => {
          item.align = 'center'
          item.width = '25%'
        });
        this.tableColumns[0].fixed = true
        this.tableColumns[1].fixed = true

      }).catch((err) => {
      })
    },
    navigateToBatch() {
      // 要切换的选中地址 与 路径参数地址 不一致时，先确认切换
      if (this.hasOriginAddressInfo && !this.isSameAsPathAddress(this.currentAddress)) {
        return this.showSwitchAddressModal = true
      }
      this.doNavigateToBatch()
    },
    doNavigateToBatch(isSwitchAddress = false) {
      if (!this.env) return
      if (this.env !== 'wechat') {
        if (isSwitchAddress) {
          const switchedAddress = this.currentAddress || {}
          console.log('kuaidi100', kuaidi100)
          kuaidi100 && kuaidi100.changeAddress({
            serverId: switchedAddress.addressId || '',
            name: switchedAddress.name || '',
            phone: switchedAddress.mobile || '',
            fixedPhone: '',
            xzqName: this.sendxzq || '',
            address: switchedAddress.address || switchedAddress.detailAddress || switchedAddress.fullAddress || '',
            success: (res) => console.log('修改地址成功', res),
            fail: (err) => console.log('修改地址失败', err),
            complete: (res) => console.log('修改地址完成', res),
          })
        }
        if (this.source === 'batch') {
          kuaidi100 && kuaidi100.close()
          return 
        } else {
          kuaidi100 && kuaidi100.navigate({
            ios: "batchOrder?selectIndex=2",
            android: "batch/placeorder",
          })
        }
      } else {
        const selectedAddress = this.currentAddress || {}
        wx.miniProgram.postMessage({
          data: {
            type: 'batchPrice',
            action: this.source === 'batch' ? 'back' : 'goBatch',
            address: selectedAddress,
            sendxzq: this.sendxzq,
            recxzq: this.recxzq,
            company: this.currentSelectCom || {},
          }
        })
        if(this.source === 'batch') {
          wx.miniProgram.navigateBack({
            delta: 1
          })
          return 
        } else {
          wx.miniProgram.navigateTo({
            url: '/pages/dispatch/batch'
          })
        }
        
      }
    },
    getRecmanList() {
      const recman = [
        {
          province: this.recxzq.split(",")[0] || '',
          city: this.recxzq.split(",")[1] || '',
          district: this.recxzq.split(",")[2] || '',
          addr: '',
          name: '',
          mobile: '',
          tel: '',
          orderData: {
            cargo: '日用品',
            cargoInput: '',
            cargoDesc: [],
            weight: 1,
          }
        }
      ]
      const list = recman
      let num = 0
      for (const i of list) {
        for (const k in i.orderData) {
          i[k] = i.orderData[k]
        }
        i.cargoDesc = i.orderData.cargoDesc?.join(',')
        // i.recxzq = `${i.province},${i.city},${i.district}`
        i.recxzq = i.xzqName
        i.recAddr = i.address
        i.recMobile = i.phone
        i.recTel = i.fixedPhone
        i.raddrid = i.id
        i.recName = i.name
        i.cargo = i.cargoInput ? i.cargoInput : i.cargo
        num = num + 1
      }
      return JSON.stringify(list)
    },
    // 显示省市区选择器
    showPicker: function(pickmode) {
      this.pickmode = pickmode
      this.region.show(this[pickmode].split(","))
    },
    // 自定义合并方法
    customSpanMethod({ row, column, rowIndex, columnIndex }){
      // 如果是第一列（收件地址）
      if (columnIndex === 0) {
        const currentValue = row.toAddress;
        
        // 计算向下合并的行数
        let rowspan = 1;
        let nextRow = rowIndex + 1;
        while (nextRow < this.tableData.length) {
          if (this.tableData[nextRow].toAddress === currentValue) {
            rowspan++;
            nextRow++;
          } else {
            break;
          }
        }
        
        // 如果不是第一个相同值的单元格，则不显示，即隐藏重复单元格
        if (rowIndex > 0 && this.tableData[rowIndex - 1].toAddress === currentValue) {
          return { rowspan: 0, colspan: 0 };
        }
        
        return { rowspan, colspan: 1 };
      }
      
      // 其他列不合并
      return { rowspan: 1, colspan: 1 };
    },
    displayXzq(xzq) {
      if (!xzq) return "请选择"
      return xzq.split(",").join("/")
    },
    toggleAddressExpand() {
      if (this.addressList.length <= 1) return
      this.isAddressExpanded = !this.isAddressExpanded
    },
    selectAddress(index) {
      if (index === this.selectedAddressIndex) return
      this.selectedAddressIndex = index
      if (this.currentSelectCom && this.currentSelectCom.customerId) {
        this.getPriceList()
      }
    },
    cancelSwitchAddress() {
      this.showSwitchAddressModal = false
    },
    confirmSwitchAddress() {
      this.showSwitchAddressModal = false
      this.doNavigateToBatch(true)
    },
  },
  
}